import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { PropsWithChildren } from 'react';
import { ExclamationIcon } from '../../icons';
import { FlexBox } from '../layout';

export interface ErrorCardProps {
  title?: string;
  message?: string | React.ReactNode;
  icon?: React.ReactNode;
}

const FallbackButtons = () => (
  <FlexBox gap={2}>
    <Button variant="outlined" href="/">
      Go home
    </Button>
    <Button variant="contained" onClick={() => window.location.reload()}>
      Reload page
    </Button>
  </FlexBox>
);

const FallBackMessage = () => (
  <FlexBox flexDirection={'column'}>
    <Typography variant="body3" color="textSecondary" align="center">
      An error occurred and we weren't able to load the page you're on.
    </Typography>
    <Typography variant="body3" color="textSecondary" align="center">
      Try refreshing the page or contact Airship support if this continues to
      happen.{' '}
      <Link component="a" href={`mailto:support@airship.us`}>
        Contact Airship
      </Link>
    </Typography>
  </FlexBox>
);

const ErrorCard: React.FC<PropsWithChildren<ErrorCardProps>> = ({
  title,
  message,
  icon,
  children,
}) => (
  <FlexBox
    flexDirection={'column'}
    alignItems={'center'}
    justifyContent={'center'}
    p={3}
    gap={3}
  >
    {icon ?? <ExclamationIcon color="#E83F34" height="48" />}
    <Typography variant="h3" align="center">
      {title || 'Something went wrong'}
    </Typography>
    {message || <FallBackMessage />}
    {children || <FallbackButtons />}
  </FlexBox>
);

export default ErrorCard;
